import { AxiosResponse } from 'axios';
import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { store } from './store';
import { Activity } from '../models/activity';

export default class QuickScanStore {
  constructor() {
    makeAutoObservable(this);
  }
  checkBoxClickedQuickScan: {
    rowData: any;
    Data: any;
    index: number;
    checked: boolean;
  } = {
    rowData: '',
    Data: '',
    index: 0,
    checked: false,
  };

  QuickscanshowBtn: {
    start: boolean;
    complete: boolean;
    Reject: boolean;
    Resolve: boolean;
    Resume: boolean;
  } = {
    start: false,
    complete: false,
    Reject: false,
    Resolve: false,
    Resume: false,
  };
  quickscanUnorderlist: any[] = [];
  quickScanTask_subtask: any = []; // array
  quickScanTaskInfo: any[] = [];
  quickScanSubtaskinfo: any[] = [];
  quickScanItemStatus: string = '';
  quickScanActivityId: any;
  quickScanbarcodeInfo: any;
  quickScanApiTrigger: boolean = false;
  checkboxCondionchekcer: any[] = [];
  QuickscancheckboxChecker: any[] = [];
  QuickscanTaskModel: boolean = false;
  Quickscantask_subtaskTrigger: boolean = false;
  QuickscanCheckboxer1: boolean = false;
  Quickscanasstabledata: {
    rowData: any;
    dataClick: boolean;
    index: number;
  } = {
    rowData: '',
    dataClick: false,
    index: 0,
  };
  WithoutbarcodeInvetoryData: string[] = [];

  quickScanshowButton = (item: any) => {
    if (item === undefined) return;
    if (item?.toLocaleLowerCase() === 'yet to start' || item === 'NA') {
      this.QuickscanshowBtn.start = true;
      this.QuickscanshowBtn.complete = false;
      this.QuickscanshowBtn.Resume = false;
      this.QuickscanshowBtn.Resolve = false;
      this.QuickscanshowBtn.Reject = false;
    } else if (item?.toLocaleLowerCase() === 'started') {
      this.QuickscanshowBtn.complete = true;
      this.QuickscanshowBtn.start = false;
      this.QuickscanshowBtn.Resume = false;
      this.QuickscanshowBtn.Resolve = false;
      this.QuickscanshowBtn.Reject = false;
    } else if (item?.toLocaleLowerCase() === 'completed') {
      this.QuickscanshowBtn.start = false;
      this.QuickscanshowBtn.complete = false;
      this.QuickscanshowBtn.Resume = false;
      this.QuickscanshowBtn.Resolve = false;
      this.QuickscanshowBtn.Reject = false;
      toast.success('completed');
    } else if (item?.toLocaleLowerCase() === 'hold') {
      this.QuickscanshowBtn.Resume = true;
      this.QuickscanshowBtn.start = false;
      this.QuickscanshowBtn.complete = false;
      this.QuickscanshowBtn.Resolve = false;
      this.QuickscanshowBtn.Reject = false;
      // this.barcodeInfoLocaltoShow();
    } else if (item?.toLocaleLowerCase() === 'rejected') {
      this.QuickscanshowBtn.Resolve = true;
      this.QuickscanshowBtn.Resume = false;
      this.QuickscanshowBtn.start = false;
      this.QuickscanshowBtn.complete = false;
      this.QuickscanshowBtn.Reject = false;
    } else if (item?.toLocaleLowerCase() === 'rework') {
      this.QuickscanshowBtn.start = false;
      this.QuickscanshowBtn.complete = false;
      this.QuickscanshowBtn.Resume = false;
      this.QuickscanshowBtn.Resolve = false;
      this.QuickscanshowBtn.Reject = false;
    } else if (
      item?.toLocaleLowerCase() === 'resume' ||
      item?.toLocaleLowerCase() === 'resumed'
    ) {
      this.QuickscanshowBtn.start = false;
      this.QuickscanshowBtn.complete = true;
      this.QuickscanshowBtn.Resume = false;
      this.QuickscanshowBtn.Resolve = false;
      this.QuickscanshowBtn.Reject = false;

      // this.barcodeInfoLocaltoShow();
    } else if (
      item?.toLocaleLowerCase() === 'resolved' ||
      item?.toLocaleLowerCase() === 'clear'
    ) {
      // resolve
      // toast.success("Resolved");
      this.QuickscanshowBtn.start = false;
      this.QuickscanshowBtn.complete = false;
      this.QuickscanshowBtn.Resume = false;
      this.QuickscanshowBtn.Resolve = false;
      this.QuickscanshowBtn.Reject = false;
    }
    //  Resolved
    else {
      this.QuickscanshowBtn.start = false;
      this.QuickscanshowBtn.complete = false;
      this.QuickscanshowBtn.Resume = false;
      this.QuickscanshowBtn.Resolve = false;
      this.QuickscanshowBtn.Reject = false;
    }
  };

  // QuickScanTask_subtaskInfo = async (item: any) => {
  //   try {
  //     let task_subtask = await agent.QuickScan.itemIdTocurrent_Task_subtask(
  //       item,
  //     );
  //     this.quickScanTask_subtask.push(task_subtask);
  //     this.quickScanActivityId = item;

  //     // task infomation
  //     let taskinfo: any[] = [];
  //     let subtaskinfo: any[] = [];
  //     taskinfo = this.quickScanTask_subtask[0]?.data?.tasks?.filter(
  //       (ele: any) => {
  //         return ele.isCurrentTask === true;
  //       },
  //     );
  //     this.quickScanTaskInfo.push(...taskinfo);
  //     // sutask infomation

  //     this.quickScanTaskInfo.forEach((ele: any) => {
  //       subtaskinfo = ele?.subTasks?.filter((item: any) => {
  //         return item.isCurrentSubtask === true;
  //       });

  //       this.quickScanSubtaskinfo.push(...subtaskinfo);
  //     });

  //     this.Quickscantask_subtaskTrigger = true;
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  barcodeinfodetailApi = async (item: any) => {
    try {
      let barcodeDetails = item.split('\n') as string[];
      barcodeDetails.pop();

      var barcodes: AxiosResponse<Activity[]> =
        await agent.QuickScan.BarcodeDetailsAPI(barcodeDetails);
      const unorder: AxiosResponse<Activity[]> =
        await agent.QuickScan.BarcodeUnorder(barcodeDetails);
      const barcodeUnroderData = unorder.data;
      const unorderData: any[] = [];

      barcodeUnroderData.forEach((item: any) => {
        unorderData.push(item?.physical_sensor_barcode);
      });
      unorderData.filter(
        (item: any, index: number) => unorderData.indexOf(item) === index,
      );

      this.quickscanUnorderlist.length = 0;
      this.quickscanUnorderlist.push(...unorderData);
      this.quickscanUnorderlist = this.quickscanUnorderlist.filter(
        (item: any, index: number) => unorderData.indexOf(item) === index,
      );

      if (barcodes) {
        let copyBarcodes: any = Object.assign([], barcodes.data);
        copyBarcodes?.forEach(() => {
          copyBarcodes['isDisabled'] = false;
        });
        this.quickScanbarcodeInfo = copyBarcodes;
      }
      if (barcodeDetails) {
        window.localStorage.setItem(
          'barcodeApi',
          JSON.stringify(barcodeDetails),
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  barcodeInfoLocaltoShow = async () => {
    try {
      if (localStorage.getItem('barcodeApi') !== '') {
        const infoDetails = localStorage.getItem('barcodeApi');
        if (infoDetails) {
          const parseinfoDetails = JSON.parse(infoDetails);
          const tempinfo = parseinfoDetails.filter((data: any) => {
            return data !== '' || data !== ' ';
          });

          setTimeout(async () => {
            var barcodes: AxiosResponse<Activity[]> =
              await agent.QuickScan.BarcodeDetailsAPI(tempinfo);
            var unorderbarcodes: AxiosResponse<Activity[]> =
              await agent.QuickScan.BarcodeUnorder(tempinfo);
            let barcodeUnorderData = unorderbarcodes.data;
            let unorderData: any[] = [];
            runInAction(() => {
              barcodeUnorderData?.forEach((item: any) => {
                unorderData.push(item?.physical_sensor_barcode);
              });
              unorderData.filter(
                (item: any, index: number) =>
                  unorderData.indexOf(item) === index,
              );
              this.quickscanUnorderlist.length = 0;
              // this.quickscanUnorderlist.push(...unorderData);
              this.quickscanUnorderlist = unorderData;

              if (barcodes) {
                this.quickScanbarcodeInfo = barcodes.data;
                this.quickScanshowButton('status changed');
              }
            });
          }, 1000);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  checkBoxClickedQuickScanFunc = (
    rowdata: any,
    data: any,
    index: number,
    checked: boolean,
  ) => {
    this.checkBoxClickedQuickScan.rowData = rowdata;
    this.checkBoxClickedQuickScan.Data = data;
    this.checkBoxClickedQuickScan.index = index;
    this.checkBoxClickedQuickScan.checked = checked;
  };
  CheckboxInfoData = (data: any, e: any) => {
    if (this.checkboxCondionchekcer.length === 0) {
      this.checkboxCondionchekcer.push(data);
    } else if (this.checkboxCondionchekcer.length > 0) {
      let bardcodes = [...this.quickScanbarcodeInfo];
      for (let i = 0; i < bardcodes.length; i++) {
        if (
          this.checkboxCondionchekcer[0]?.status === bardcodes[i]?.status &&
          this.checkboxCondionchekcer[0]?.current_task ===
            bardcodes[i]?.current_task &&
          this.checkboxCondionchekcer[0]?.current_subtask ===
            bardcodes[i]?.current_subtask
        ) {
          this.checkboxCondionchekcer.push(data);
        } else {
          this.checkboxCondionchekcer.length = 0;
          this.checkboxCondionchekcer.push(data);
        }
      }
    }
  };

  QuickScanStatusChanger = async (value: string, status: string) => {
    try {
      store.activityStore.loadCountAssetTable = true;
      if (this.QuickscancheckboxChecker.length > 0) {
        const temparray: string[] = [];
        this.QuickscancheckboxChecker.forEach((data: any) => {
          temparray.push(data.physical_sensor_barcode);
        });
        if (temparray.length > 0) {
          const subtaskinfo = await agent.QuickScan.Idbased_subtask(temparray);
          // var subtaskinfo:AxiosResponse<Activity[]> = await agent.QuickScan.Idbased_subtask(temparray);
          if (subtaskinfo) {
            let subtaskinfodata = subtaskinfo.data;

            subtaskinfodata?.forEach(async (data: any) => {
              // eslint-disable-next-line
              const status = new Promise(async (resolve) => {
                // eslint-disable-next-line
                let iteminfo: any = await agent.QuickScan.statuschanger(
                  data,
                  value,
                );

                resolve('');
              });

              status.then(() => {
                if (value === '2') {
                  this.barcodeInfoLocaltoShow();
                  setTimeout(() => {
                    store.activityStore.loadCountAssetTable = false;
                  }, 2000);
                } else {
                  setTimeout(() => {
                    store.activityStore.loadCountAssetTable = false;
                  }, 1500);
                }
              });
            });

            // this.QuickScanTask_subtaskInfo(iteminfo);
            // toast.success(status);
            let temparr: any[] = [];

            this.QuickscancheckboxChecker.forEach((data: any) => {
              temparr.push(data.id);
              // this.QuickScanTask_subtaskInfo(data.id);
            });

            // console.log("dataaaaa", temparr);
            if (temparr.length > 0) {
              //  this.QuickScanTask_subtaskInfo(temparr?.[0]);
            }

            // this.QuickScanTask_subtaskInfo(temparr?.[0]);
            if (value !== '2') this.barcodeInfoLocaltoShow();
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  QuickscanAllData = async (
    pagenumber: number,
    id: string,
    pageSize: number,
  ) => {
    try {
      store.activityStore.loadCountAssetTable = true;
      const activities =
        store.userStore.user?.customerName === 'LVPCMS'
          ? await agent.Activities.listPaginationLVP(id, pagenumber, pageSize)
          : await agent.Activities.listPagination({
              pageNo: pagenumber,
              pageSize: pageSize,
              searchDate: '',
            });
      store.activityStore.activityRegistry = new Map<string, Activity>();
      runInAction(() => {
        this.quickScanbarcodeInfo = activities;
      });
      store.activityStore.loadCountAssetTable = false;
    } catch (error) {}
  };

  QuickscanCheckboxfalse = (item: boolean) => {
    this.QuickscanCheckboxer1 = item;
  };
  QuickscanAsstableClicked = (rowData: any, click: boolean, index: number) => {
    this.Quickscanasstabledata.rowData = rowData;
    this.Quickscanasstabledata.dataClick = click;
    this.Quickscanasstabledata.index = index;
  };
  barcodeInvetoryDatagetter = async (
    params: {
      typeId: string;
      elementId: string;
      currentTask: string;
      currentSubtask: string;
      status: string;
    },
    condition: boolean,
  ) => {
    try {
      if (condition) {
        const invetoryData =
          await agent.QuickScan.WithoutBarcodeInventory(params);
        runInAction(() => {
          this.WithoutbarcodeInvetoryData = invetoryData.data;
        });
      } else {
        this.WithoutbarcodeInvetoryData.length = 0;
      }
    } catch (error) {
      console.log(error);
    }
  };

  InventoryLoopStatusChanger = async (
    itemId: string,
    status: number,
    orderStatus: string,
  ) => {
    try {
      //
      this.Quickscantask_subtaskTrigger = true;
      await agent.QuickScan.InventoryStatusChangerPut(
        itemId,
        status,
        orderStatus,
      );
      this.Quickscantask_subtaskTrigger = false;
    } catch (error) {
      console.log(error);
      this.Quickscantask_subtaskTrigger = false;
    }
  };
}
